import { service as authService } from '@/auth/auth-service'
import { service as authResourceService } from '@/auth/auth-resource-service'
import { service as boardService } from '@/api/board'
import { service as documentService } from '@/api/document'
import { service as profileService } from '@/api/profile'
import {
    /* auth */
    FETCH_AUTH_RESOURCE_REQUEST,
    FETCH_AUTH_RESOURCE_SUCCESS,
    FETCH_AUTH_RESOURCE_FAILED,
    CREATE_MEMBER_AUTH_REQUEST,
    CREATE_MEMBER_AUTH_SUCCESS,
    CREATE_MEMBER_AUTH_FAILED,
    DELETE_MEMBER_AUTH_REQUEST,
    DELETE_MEMBER_AUTH_SUCCESS,
    DELETE_MEMBER_AUTH_FAILED,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CREATE_MEMBER_AUTH_AGAIN_REQUEST,
    CREATE_MEMBER_AUTH_AGAIN_SUCCESS,
    CREATE_MEMBER_AUTH_AGAIN_FAILED,
    CREATE_MEMBER_AUTH_OTP_REQUEST,
    CREATE_MEMBER_AUTH_OTP_SUCCESS,
    CREATE_MEMBER_AUTH_OTP_FAILED,
    /* Board */
    FETCH_BOARD_DOCUMENTS_REQUEST,
    FETCH_BOARD_DOCUMENTS_SUCCESS,
    FETCH_BOARD_DOCUMENTS_FAILED,
    FETCH_BOARD_DOCUMENT_REQUEST,
    FETCH_BOARD_DOCUMENT_SUCCESS,
    FETCH_BOARD_DOCUMENT_FAILED,
    /* Profile */
    FETCH_LOG_HISTORY_REQUEST,
    FETCH_LOG_HISTORY_SUCCESS,
    FETCH_LOG_HISTORY_FAILED,
    FETCH_USER_INFO_REQUEST,
    FETCH_USER_INFO_SUCCESS,
    FETCH_USER_INFO_FAILED,
    FETCH_CHANGE_PASSWORD_REQUEST,
    FETCH_CHANGE_PASSWORD_SUCCESS,
    FETCH_CHANGE_PASSWORD_FAILED,
    FETCH_CHANGE_LATER_REQUEST,
    FETCH_CHANGE_LATER_SUCCESS,
    FETCH_CHANGE_LATER_FAILED,
    CREATE_OTP_REQUEST,
    CREATE_OTP_SUCCESS,
    CREATE_OTP_FAILED,
    DELETE_OTP_REQUEST,
    DELETE_OTP_SUCCESS,
    DELETE_OTP_FAILED,
    CREATE_AGREE_DOCUMENT_REQUEST,
    CREATE_AGREE_DOCUMENT_SUCCESS,
    CREATE_AGREE_DOCUMENT_FAILED,
    /* Document */
    FETCH_AGREE_VERSION_REQUEST,
    FETCH_AGREE_VERSION_SUCCESS,
    FETCH_AGREE_VERSION_FAILED,
    FETCH_AGREE_DOCUMENT_REQUEST,
    FETCH_AGREE_DOCUMENT_SUCCESS,
    FETCH_AGREE_DOCUMENT_FAILED,
    FETCH_PRIVACY_VERSION_REQUEST,
    FETCH_PRIVACY_VERSION_SUCCESS,
    FETCH_PRIVACY_VERSION_FAILED,
    FETCH_PRIVACY_DOCUMENT_REQUEST,
    FETCH_PRIVACY_DOCUMENT_SUCCESS,
    FETCH_PRIVACY_DOCUMENT_FAILED
} from './mutation-type'
/*
    auth
*/
const getAuthResource = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_AUTH_RESOURCE_REQUEST)
    try {
        const { data } = await authResourceService.authResource()
        commit(FETCH_AUTH_RESOURCE_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_AUTH_RESOURCE_FAILED, error)
        return Promise.reject(error)
    }
}
const createTokenAuth = async ({ commit, state, getters, rootGetters }, { email }) => {
    commit(CREATE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.tokenSignin({ email })
        commit(CREATE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_FAILED, error)
        return Promise.reject(error)
    }
}
const createMemberAuth = async ({ commit, state, getters, rootGetters }, { email, password }) => {
    commit(CREATE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.memberSignin({ email, password })
        commit(CREATE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_FAILED, error)
        return Promise.reject(error)
    }
}
const createMemberAuthOtp = async ({ commit, state, getters, rootGetters }, { otpCode }) => {
    commit(CREATE_MEMBER_AUTH_OTP_REQUEST)
    try {
        const { data } = await authService.memberSigninOtp({ otpCode })
        commit(CREATE_MEMBER_AUTH_OTP_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_OTP_FAILED, error)
        return Promise.reject(error)
    }
}
const deleteMemberAuth = async ({ commit, state, getters, rootGetters }, { id }) => {
    commit(DELETE_MEMBER_AUTH_REQUEST)
    try {
        const { data } = await authService.memberSignout({ id })
        commit(DELETE_MEMBER_AUTH_SUCCESS, data)
        return data
    } catch (error) {
        commit(DELETE_MEMBER_AUTH_FAILED, error)
        throw error
    }
}
const resetPassword = async ({ commit, state, getters, rootGetters }, { email }) => {
    commit(RESET_PASSWORD_REQUEST)
    try {
        const { data } = await profileService.resetPassword({ email })
        commit(RESET_PASSWORD_SUCCESS, data)
        return data
    } catch (error) {
        commit(RESET_PASSWORD_FAILED, error)
        throw error
    }
}
const createMemberAuthAgain = async ({ commit, state, getters, rootGetters }, { email }) => {
    commit(CREATE_MEMBER_AUTH_AGAIN_REQUEST)
    try {
        const { data } = await authService.memberSigninAgain({ email })
        commit(CREATE_MEMBER_AUTH_AGAIN_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_MEMBER_AUTH_AGAIN_FAILED, error)
        throw error
    }
}

/* board */
const getBoardDocuments = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_BOARD_DOCUMENTS_REQUEST)
    try {
        const { data } = await boardService.getBoardDocuments()
        commit(FETCH_BOARD_DOCUMENTS_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_BOARD_DOCUMENTS_FAILED, error)
        throw error
    }
}

const getBoardDocument = async ({ commit, state, getters, rootGetters }, { timestamp, service }) => {
    commit(FETCH_BOARD_DOCUMENT_REQUEST)
    try {
        const { data } = await boardService.getBoardDocument({ timestamp, service })
        commit(FETCH_BOARD_DOCUMENT_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_BOARD_DOCUMENT_FAILED, error)
        throw error
    }
}

/* profile */
const getUserSigninHistory = async ({ commit, state, getters, rootGetters }, { userIdx }) => {
    commit(FETCH_LOG_HISTORY_REQUEST)
    try {
        const { data } = await profileService.getUserSigninHistory(userIdx)
        commit(FETCH_LOG_HISTORY_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_LOG_HISTORY_FAILED, error)
        throw error
    }
}
const getProfileUserInfo = async ({ commit, state, getters, rootGetters }, { userIdx }) => {
    commit(FETCH_USER_INFO_REQUEST)
    try {
        const { data } = await profileService.getProfileUserInfo(userIdx)
        commit(FETCH_USER_INFO_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_USER_INFO_FAILED, error)
        throw error
    }
}
const setChangePassword = async ({ commit, state, getters, rootGetters }, { userIdx, currentPassword, newPassword, newPasswordConfirm }) => {
    commit(FETCH_CHANGE_PASSWORD_REQUEST)
    try {
        const { data, status } = await profileService.changePassword({ userIdx, currentPassword, newPassword, newPasswordConfirm })
        commit(FETCH_CHANGE_PASSWORD_SUCCESS, data)
        return { data, status }
    } catch (error) {
        commit(FETCH_CHANGE_PASSWORD_FAILED, error)
        throw error
    }
}
const setChangeLater = async ({ commit, state, getters, rootGetters }, { userIdx }) => {
    commit(FETCH_CHANGE_LATER_REQUEST)
    try {
        const { data } = await profileService.changeLater(userIdx)
        commit(FETCH_CHANGE_LATER_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_CHANGE_LATER_FAILED, error)
        throw error
    }
}
const setOtp = async ({ commit, state, getters, rootGetters }, { userIdx, secretKey }) => {
    commit(CREATE_OTP_REQUEST)
    try {
        const { data } = await profileService.setOtp({ userIdx, secretKey })
        commit(CREATE_OTP_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_OTP_FAILED, error)
        throw error
    }
}
const unsetOtp = async ({ commit, state, getters, rootGetters }, { userIdx }) => {
    commit(DELETE_OTP_REQUEST)
    try {
        const { data } = await profileService.unsetOtp(userIdx)
        commit(DELETE_OTP_SUCCESS, data)
        return data
    } catch (error) {
        commit(DELETE_OTP_FAILED, error)
        throw error
    }
}
const signAgreement = async ({ commit, state, getters, rootGetters }, { userIdx, signedTc }) => {
    commit(CREATE_AGREE_DOCUMENT_REQUEST)
    try {
        const { data } = await profileService.signAgreement({ userIdx, signedTc })
        commit(CREATE_AGREE_DOCUMENT_SUCCESS, data)
        return data
    } catch (error) {
        commit(CREATE_AGREE_DOCUMENT_FAILED, error)
        throw error
    }
}

/* document */
// const getAgreementDocument = async ({ commit, state, getters, rootGetters }, version) => {
//     commit(FETCH_AGREE_DOCUMENT_REQUEST)
//     try {
//         const { data } = await documentService.getAgreementDocument(version)
//         commit(FETCH_AGREE_DOCUMENT_SUCCESS, data)
//         return data
//     } catch (error) {
//         commit(FETCH_AGREE_DOCUMENT_FAILED, error)
//         throw error
//     }
// }

const getAgreementDocumentVersions = async ({ commit, state, getters, rootGetters }, { locale }) => {
    commit(FETCH_AGREE_VERSION_REQUEST)
    try {
        const { data } = await documentService.getAgreementDocumentVersions(locale)
        commit(FETCH_AGREE_VERSION_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_AGREE_VERSION_FAILED, error)
        throw error
    }
}

const getAgreementDocumentContent = async ({ commit, state, getters, rootGetters }, { version, locale }) => {
    commit(FETCH_AGREE_DOCUMENT_REQUEST)
    try {
        const { data } = await documentService.getAgreementDocumentContent(version, locale)
        commit(FETCH_AGREE_DOCUMENT_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_AGREE_DOCUMENT_FAILED, error)
        throw error
    }
}

const getPrivacyDocumentVersions = async ({ commit, state, getters, rootGetters }, { locale }) => {
    commit(FETCH_PRIVACY_VERSION_REQUEST)
    try {
        const { data } = await documentService.getPrivacyDocumentVersions(locale)
        commit(FETCH_PRIVACY_VERSION_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_PRIVACY_VERSION_FAILED, error)
        throw error
    }
}

const getPrivacyDocumentContent = async ({ commit, state, getters, rootGetters }, { version, locale }) => {
    commit(FETCH_PRIVACY_DOCUMENT_REQUEST)
    try {
        const { data } = await documentService.getPrivacyDocumentContent(version, locale)
        commit(FETCH_PRIVACY_DOCUMENT_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_PRIVACY_DOCUMENT_FAILED, error)
        throw error
    }
}

export default {
    /* auth */
    getAuthResource,
    createTokenAuth,
    createMemberAuth,
    deleteMemberAuth,
    resetPassword,
    createMemberAuthAgain,
    createMemberAuthOtp,
    /* board */
    getBoardDocuments,
    getBoardDocument,
    /* profile */
    getUserSigninHistory,
    getProfileUserInfo,
    setChangePassword,
    setChangeLater,
    setOtp,
    unsetOtp,
    signAgreement,
    /* document */
    // getAgreementDocument,
    getAgreementDocumentVersions,
    getAgreementDocumentContent,
    getPrivacyDocumentVersions,
    getPrivacyDocumentContent
}
